import VueBaseController from '../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/locations/index.vue') }

  static values = {
    mapKey: String
  }
}
